
export default function InsuranceDetails() {
  return (
    <section id="insurance-details" className="py-32 bg-gradient-to-br from-white via-[#E8F4F8] to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#4A90E2]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#4A90E2]/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2 bg-[#4A90E2]/10 text-[#4A90E2] text-sm font-semibold rounded-full mb-6">
            INSURANCE DETAILS
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            장기요양기관 배상책임보험이란?
          </h2>
          <p>
            장기요양기관이 서비스 제공 중 발생한 사고로 인해 법적 배상책임을 부담할 때<br />
            보험금을 지급하는 필수 보험입니다
          </p>
        </div>

        {/* Main Content with Image and Legal Basis */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start mb-24">
          {/* Image */}
          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-br from-[#4A90E2]/20 to-transparent rounded-3xl transform rotate-3 group-hover:rotate-6 transition-transform duration-500"></div>
            <img 
              src="https://public.readdy.ai/ai/img_res/1308445be0592f3edad93112d41c7872.jpg"
              alt="장기요양기관 배상책임보험"
              className="relative rounded-3xl shadow-2xl w-full h-[500px] object-cover transform group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 border-2 border-[#4A90E2]/20">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#4A90E2]/10 rounded-xl flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-[#4A90E2]"></i>
                </div>
                <div>
                  <p>필수 가입</p>
                  <p>법정 의무보험</p>
                </div>
              </div>
            </div>
          </div>

          {/* Legal Basis Details */}
          <div className="bg-gradient-to-br from-[#4A90E2]/5 to-white rounded-2xl p-8 shadow-lg border-2 border-[#4A90E2]/20">
            <h4 className="text-2xl font-bold text-gray-900 mb-6 whitespace-nowrap">법적 근거</h4>
            
            <div className="space-y-4">
              <div className="bg-[#1F606F]/5 rounded-xl p-6 hover:shadow-md transition-all duration-300">
                <h5 className="font-bold text-gray-900 mb-2 text-base whitespace-nowrap">사회복지사업법 제34조의3</h5>
                <div className="text-sm text-gray-700 leading-relaxed">
                  시설 운영자는 화재 및 안전사고로 인한 손해배상 책임 이행을 위해
                  책임보험 또는 책임공제에 가입해야 함을 규정하고 있습니다.
                </div>
              </div>

              <div className="bg-[#1F606F]/5 rounded-xl p-6 hover:shadow-md transition-all duration-300">
                <h5 className="font-bold text-gray-900 mb-2 text-base whitespace-nowrap">노인장기요양보험법 제35조의5</h5>
                <div className="text-sm text-gray-700 leading-relaxed">
                  장기요양기관은 종사자가 급여 제공 과정에서 수급자에게 입힌 손해를 배상하기 위해
                  전문인 배상책임보험에 반드시 가입해야 함을 명시하고 있습니다.
                </div>
              </div>

              <div className="bg-[#1F606F]/5 rounded-xl p-6 hover:shadow-md transition-all duration-300">
                <h5 className="font-bold text-gray-900 mb-2 text-base whitespace-nowrap">장기요양급여 제공기준 고시 제10조</h5>
                <div className="text-sm text-gray-700 leading-relaxed">
                  시설 유형별·급여 유형별 구체적인 가입 기준을 명확히 규정합니다.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Notice - 미가입 시 불이익 */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <h3 className="text-3xl font-bold text-gray-900 mb-3 whitespace-nowrap">미가입 시 불이익</h3>
            <p>장기요양기관 배상책임보험 미가입 시 다음과 같은 불이익이 발생합니다</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-6 shadow-lg border-2 border-red-200 hover:shadow-xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-12 h-12 bg-red-500 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-close-circle-line text-2xl text-white"></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2 whitespace-nowrap">지정 취소</h4>
              <p>
                장기요양기관 지정 취소 또는
              </p>
              <p>
                업무정지 처분
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-6 shadow-lg border-2 border-red-200 hover:shadow-xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-12 h-12 bg-red-500 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-file-forbid-line text-2xl text-white"></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2 whitespace-nowrap">청구 제한</h4>
              <p>
                장기요양급여비용
              </p>
              <p>
                청구 제한
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-6 shadow-lg border-2 border-red-200 hover:shadow-xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-12 h-12 bg-red-500 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-percent-line text-2xl text-white"></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2 whitespace-nowrap">비용 감액</h4>
              <p>
                장기요양급여비용 10% 감액
              </p>
              <p>
                (동 고시 제68조)
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-6 shadow-lg border-2 border-red-200 hover:shadow-xl hover:-translate-y-2 transition-all duration-300">
              <div className="w-12 h-12 bg-red-500 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2 whitespace-nowrap">재정 위험</h4>
              <p>
                사고 발생 시 전액 자비 부담으로
              </p>
              <p>
                인한 재정적 위험
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Content - Horizontal Layout */}
        <div className="space-y-8 mb-24">
          {/* 시설 유형별 가입 대상 기준 - 간결한 디자인 */}
          <div className="bg-white rounded-2xl p-10 shadow-lg border-2 border-[#4A90E2]/20">
            <div className="flex items-start gap-4 mb-8">
              <div className="w-12 h-12 bg-[#4A90E2]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-building-line text-2xl text-[#4A90E2]"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 pt-2">시설 유형별 가입 대상 기준</h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* 시설급여 */}
              <div className="bg-gradient-to-br from-[#4A90E2]/5 to-[#4A90E2]/10 rounded-xl p-6 border border-[#4A90E2]/20 flex flex-col">
                <h4 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-home-heart-line text-xl text-[#4A90E2]"></i>
                  시설급여
                </h4>
                <p className="mb-4">
                  노인요양시설 · 노인요양공동생활가정 · 단기보호 · 주·야간보호
                </p>
                <div className="bg-white rounded-lg p-4 border border-[#4A90E2]/20 mt-auto">
                  <p>
                    가입 기준 : 종사자 또는 현원 기준
                  </p>
                  <p className="text-xs text-gray-600 mt-2">
                    (장기요양급여 제공기준 등에 관한 고시 : 종사자 또는 현원 전원 가입)
                  </p>
                </div>
              </div>

              {/* 재가급여 */}
              <div className="bg-gradient-to-br from-[#10B981]/5 to-[#10B981]/10 rounded-xl p-6 border border-[#10B981]/20 flex flex-col">
                <h4 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-home-smile-line text-xl text-[#10B981]"></i>
                  재가급여
                </h4>
                <p className="mb-4">
                  방문요양 · 방문목욕 · 방문간호기관
                </p>
                <div className="bg-white rounded-lg p-4 border border-[#10B981]/20 mt-auto">
                  <p>
                    가입 기준 : 종사자 기준
                  </p>
                  <p className="text-xs text-gray-600 mt-2">
                    (장기요양급여 제공기준 등에 관한 고시 : 종사자 전원 가입)
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 보장 한도 비교 */}
        </div>

        {/* Coverage Details */}
        <div className="bg-gradient-to-br from-white to-[#E8F4F8] rounded-3xl p-12 shadow-xl border-2 border-[#4A90E2]/20 mb-24">
          <h3 className="text-3xl font-bold text-gray-900 mb-12 text-center whitespace-nowrap">보장 내용</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-14 h-14 bg-[#4A90E2]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-3xl text-[#4A90E2]"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">신체 손해</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#4A90E2] text-lg mt-0.5"></i>
                  <span className="text-sm text-gray-600">낙상, 욕창, 골절 등 신체적 상해</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#4A90E2] text-lg mt-0.5"></i>
                  <span className="text-sm text-gray-600">의료사고로 인한 건강 악화</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#4A90E2] text-lg mt-0.5"></i>
                  <span className="text-sm text-gray-600">사망 사고</span>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-14 h-14 bg-[#4A90E2]/10 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-hospital-line text-3xl text-[#4A90E2]"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">배상 범위</h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#4A90E2] text-lg mt-0.5"></i>
                  <span className="text-sm text-gray-600">치료비 및 입원비</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#4A90E2] text-lg mt-0.5"></i>
                  <span className="text-sm text-gray-600">위자료 및 손해배상금</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-[#4A90E2] text-lg mt-0.5"></i>
                  <span className="text-sm text-gray-600">소송비용 및 변호사 선임비</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-[#4A90E2]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-[#4A90E2] to-[#357ABD] rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">법정 의무보험</h4>
            <p>
              노인장기요양보험법에 따라 모든 장기요양기관이 반드시 가입해야 하는 필수 보험입니다.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-[#4A90E2]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-[#4A90E2] to-[#357ABD] rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-user-heart-line text-3xl text-white"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">수급자 보호</h4>
            <p>
              장기요양 서비스 이용 중 발생한 사고로부터 수급자를 보호하고 적절한 보상을 보장합니다.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-[#4A90E2]/20 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-[#4A90E2] to-[#357ABD] rounded-2xl flex items-center justify-center mb-6 mx-auto">
              <i className="ri-building-line text-3xl text-white"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-4 text-center whitespace-nowrap">시설 보호</h4>
            <p>
              예상치 못한 사고로 인한 시설의 재정적 부담을 경감하고 안정적인 운영을 지원합니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
